// Shared company facts for the shop: contact details in the footer, product
// pages and enquiry CTA, plus the company ISO credentials on /certifications.
// Team, mission/vision, service lists, top-seller copy and individual engineer
// certifications all moved to quantarock.in.

// Joined at runtime rather than written as one literal. The compiled bundle is
// public, and spam harvesters grep it for name@domain.tld; a minifier will fold
// string concatenation but not Array#join, so no such substring exists until
// the browser builds it. Everything downstream still reads plain strings, so
// mailto: links and displayed addresses are unaffected.
const MAIL_ID = ["info", "quantarock.in"].join("@");

export const COMPANY_DATA = {
  mailID: MAIL_ID,
  phoneNumber: "+91-9755010858",
  companyName: "QuantaRock Systems Private Limited",
  ceoName: "Vipendra Mehra",
  address:
    "444, Shyam Nagar(main), Sukhliya Indore, Madhya Pradesh, India - 452010",
  linkedInURL: "https://www.linkedin.com/company/quantarock-systems",
  mailURL: `mailto:${MAIL_ID}`,
  twitterURL: "https://twitter.com/VipendramehraVM",
  instaURL: "https://www.instagram.com/quantarock_systems_india/",
  facebookURL:
    "https://www.facebook.com/people/QuantaRock-Systems/61550422080802/",
  youtubeURL: "https://www.youtube.com/@Quantarock",
  careerFormLink: "https://form.jotform.com/242311429569459",
  webDomain: "https://quantarock.in/",
};

export const CERTIFICATES_DATA = [
  {
    id: "iso27001",
    title: "ISO 27001:2022",
    description:
      "Information Security Management Systems certification ensuring robust security controls and risk management practices.",
    issueDate: "10/09/2025",
    expiryDate: "09/09/2028",
    imgSrc: "Registration.jpg", // preview scan in public/assets/certificates/
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED 27001 FINAL ICV.pdf", // adjust public path
  },
  {
    id: "iso9001",
    title: "ISO 9001:2015",
    description:
      "Quality Management System certification demonstrating our commitment to consistent quality and customer satisfaction.",
    issueDate: "16/09/2025",
    expiryDate: "15/09/2028",
    imgSrc: "ISO.jpg", // preview scan in public/assets/certificates/
    file: "/files/QUANTAROCK SYSTEMS PRIVATE LIMITED QMS.pdf", // adjust public path
  },
];
